export default __webpack_public_path__ + "img/dataexport.341d5239.jpg";